export default __webpack_public_path__ + "static/media/argentina.56972769.svg";